import { useMutation } from '@apollo/client';
import { useState } from 'react';

import { useCompleteFragment } from '@eluve/apollo-client';
import { NewButton, Textarea, useToast } from '@eluve/components';
import { useAnalytics } from '@eluve/posthog-react';
import {
  useAssignedTenantIdFromParams,
  useUserIdFromSession,
} from '@eluve/session-helpers';

import {
  tenantUserSettingsFragment,
  updateProviderDetailsMutation,
} from './operations';

export const ProviderDetailsSetting: React.FC = () => {
  const toast = useToast();
  const userId = useUserIdFromSession();
  const tenantId = useAssignedTenantIdFromParams();

  const { settings } = useCompleteFragment({
    fragment: tenantUserSettingsFragment,
    key: { userId, tenantId },
  });

  const analytics = useAnalytics('user_settings');

  const [updateProvideDetails] = useMutation(updateProviderDetailsMutation, {
    onError: () => {
      toast.error('Failed to update profile');
    },
    optimisticResponse: (data) => ({
      updateTenantUserSettingsByPk: {
        __typename: 'TenantUserSettings' as const,
        tenantId,
        userId,
        providerDetails: data.providerDetails,
      },
    }),
    onCompleted: (data) => {
      if (data.updateTenantUserSettingsByPk) {
        const { tenantId, userId } = data.updateTenantUserSettingsByPk;
        analytics.capture('medical_provider_details_update', {
          tenantId,
          userId,
        });
      }
    },
  });

  const save = async () => {
    if (providerDetails !== null) {
      await updateProvideDetails({
        variables: {
          tenantId,
          userId,
          providerDetails,
        },
      });
    }
  };

  const [providerDetails, setProviderDetails] = useState<string>(
    settings?.providerDetails ?? '',
  );

  return (
    <>
      <Textarea
        placeholder="Type medical provider details here"
        rows={4}
        value={providerDetails}
        onChange={(e) => {
          setProviderDetails(e.target.value);
        }}
      />
      <NewButton
        text="Save"
        onClick={save}
        type="primary"
        disabled={
          providerDetails == null ||
          providerDetails === settings?.providerDetails
        }
      />
    </>
  );
};
